import GatewayService from "@/services/GatewayService";
import moment from "moment";
const state = {
  gateways: [],
  gatewayDeviceInfo: [],
  gatewayInfo: [],
};
const getters = {
  getGatewayData: (state) => state.gateways,
  getGatewayDeviceInfo: (state) => state.gatewayInfo,
  getGatewayInfoPondWise: (state) => {
    const keyToDeviceMap = {
      pond_guards: "POND_GUARD",
      pond_mothers: "POND_MOTHER",
      shrimp_talks: "SHRIMP_TALK",
    };
    return state.gatewayDeviceInfo.reduce(
      (acc, { gateway_data = [], title: pond_title }) => {
        gateway_data.forEach(
          ({ code: gateway_code, devices = {}, title: gateway_title }) => {
            ["pond_mothers", "pond_guards", "shrimp_talks"].forEach((key) => {
              (devices[key] || []).forEach(
                ({
                  code: device_code,
                  title: device_title,
                  status: device_status,
                }) => {
                  acc.push({
                    pond_title,
                    device_title,
                    device_code,
                    device_type: keyToDeviceMap[key],
                    device_status,
                    gateway_code,
                    gateway_title,
                  });
                }
              );
            });
          }
        );
        return acc;
      },
      []
    );
  },
  getGatewayInfoTabData: (state, getters) => {
    const arrGateways = getters.getGatewayDeviceInfo;
    return arrGateways.map((gateway) => {
      const utc_last_comm_time = gateway.utc_last_communicated_at;
      const timeDiff = moment
        .utc(utc_last_comm_time || -1)
        .diff(moment(), "minutes");
      gateway.lora_channel = gateway.settings.lora_channel;
      gateway.ip_address = gateway.settings.ip_address;
      gateway.wifi_networks = gateway.settings.wifi_networks;
      gateway.mac_address = gateway.settings.mac_address;
      gateway.signal = (gateway.sensor_values || {}).wifi_signal_RSSI;
      gateway.wifi_connection = (gateway.sensor_values || {}).wifi_connection;
      gateway.comm_time_diff = timeDiff;
      return gateway;
    });
  },
};
const mutations = {
  SET_GATEWAY_DATA(state, gatewaysData) {
    state.gateways = gatewaysData;
  },

  SET_GATEWAY_DEVICE_INFO_DATA(state, gatewayDeviceInfo) {
    state.gatewayDeviceInfo = gatewayDeviceInfo;
  },
  SET_GATEWAY_INFO_DATA(state, gatewayInfo) {
    state.gatewayInfo = gatewayInfo;
  },
};
const actions = {
  async fetchGatewayData(context) {
    context.commit("SET_GATEWAY_DATA", []);
    const response = await GatewayService.fetchGatewayData();
    context.commit("SET_GATEWAY_DATA", response.data.gateways);
  },
  async fetchGatewayInfoData(context, params) {
    const response = await GatewayService.fetchGatewayInfoData(params);
    context.commit("SET_GATEWAY_INFO_DATA", response.data.gateways);
  },
  async fetchGatewayDeviceInfoData(context, params) {
    const response = await GatewayService.fetchGatewayDeviceInfoData(params);
    context.commit("SET_GATEWAY_DEVICE_INFO_DATA", response.data.pond_data);
  },
  async saveGatewayDetails(context, payload) {
    const modifiedPayload = payload.map((ele) => ({
      gateway_id: ele._id,
      title: ele.title,
    }));
    await GatewayService.saveGatewayDetails(modifiedPayload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
